import styled from 'styled-components';

export const StyledSimpleImage = styled.div.attrs(
  ({ responsiveTransform, originalSize }) => {
    return {
      style: {
        '--width': `${responsiveTransform.width}px`,
        '--height': `${responsiveTransform.height}px`,

        '--imageWidth': `${originalSize.width}px`,
        '--imageHeight': `${originalSize.height}px`,
        '--x': `${responsiveTransform.x}px`,
        '--y': `${responsiveTransform.y}px`,
        '--scaleX': responsiveTransform.scaleX,
        '--scaleY': responsiveTransform.scaleY,
      },
    };
  }
)`
  position: absolute;
  width: var(--width);
  height: var(--height);
  transform: translate(var(--x), var(--y));

  .game-object-wrapper {
    position: absolute;
    transform-origin: left top;
    transform: scale(var(--scaleX), var(--scaleY));
    width: var(--imageWidth);
    height: var(--imageHeight);
    overflow: hidden;

    .game-object {
      position: absolute;
      display: block;
    }

    .debug-grid {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .grid-box {
        width: 50%;
        height: 50%;
        border: 1px dashed coral;
      }
    }
  }
`;
